// extracted by mini-css-extract-plugin
module.exports = {"leftBorder":"LeftBorder_leftBorder__RQAyU","path":"LeftBorder_path__c5lSs"};